// extracted by mini-css-extract-plugin
export default {"section":"NotFound_section__0K6vp","center":"NotFound_center__eonwR"};